import { render, staticRenderFns } from "./CadastroUnidadeNegocio.vue?vue&type=template&id=772f3562&scoped=true&"
import script from "./CadastroUnidadeNegocio.vue?vue&type=script&lang=js&"
export * from "./CadastroUnidadeNegocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f3562",
  null
  
)

export default component.exports